// Auto-generated from /avatars/eyes/*.svg by build script.
// Each pattern is rendered inline in SamAvatar so the user can choose any color.
// Schema: Record<eyeId, Array<{ shade: 'primary'|'bright', rects: [x,y,w,h][] }>>

export type EyeShade = 'primary' | 'bright';
export interface EyeGroup { shade: EyeShade; rects: Array<[number, number, number, number]>; }

export const EYE_PATTERNS: Record<string, EyeGroup[]> = {
  "bot-attentive": [
    {
      "shade": "primary",
      "rects": [
        [
          8.0,
          4.0,
          4.0,
          4.0
        ],
        [
          12.0,
          4.0,
          4.0,
          4.0
        ],
        [
          16.0,
          4.0,
          4.0,
          4.0
        ],
        [
          20.0,
          4.0,
          4.0,
          4.0
        ],
        [
          24.0,
          4.0,
          4.0,
          4.0
        ],
        [
          36.0,
          4.0,
          4.0,
          4.0
        ],
        [
          40.0,
          4.0,
          4.0,
          4.0
        ],
        [
          44.0,
          4.0,
          4.0,
          4.0
        ],
        [
          48.0,
          4.0,
          4.0,
          4.0
        ],
        [
          52.0,
          4.0,
          4.0,
          4.0
        ],
        [
          8.0,
          8.0,
          4.0,
          4.0
        ],
        [
          12.0,
          8.0,
          4.0,
          4.0
        ],
        [
          16.0,
          8.0,
          4.0,
          4.0
        ],
        [
          20.0,
          8.0,
          4.0,
          4.0
        ],
        [
          24.0,
          8.0,
          4.0,
          4.0
        ],
        [
          36.0,
          8.0,
          4.0,
          4.0
        ],
        [
          40.0,
          8.0,
          4.0,
          4.0
        ],
        [
          44.0,
          8.0,
          4.0,
          4.0
        ],
        [
          48.0,
          8.0,
          4.0,
          4.0
        ],
        [
          52.0,
          8.0,
          4.0,
          4.0
        ],
        [
          8.0,
          12.0,
          4.0,
          4.0
        ],
        [
          12.0,
          12.0,
          4.0,
          4.0
        ],
        [
          16.0,
          12.0,
          4.0,
          4.0
        ],
        [
          20.0,
          12.0,
          4.0,
          4.0
        ],
        [
          24.0,
          12.0,
          4.0,
          4.0
        ],
        [
          36.0,
          12.0,
          4.0,
          4.0
        ],
        [
          40.0,
          12.0,
          4.0,
          4.0
        ],
        [
          44.0,
          12.0,
          4.0,
          4.0
        ],
        [
          48.0,
          12.0,
          4.0,
          4.0
        ],
        [
          52.0,
          12.0,
          4.0,
          4.0
        ]
      ]
    }
  ],
  "bot-focused": [
    {
      "shade": "primary",
      "rects": [
        [
          8.0,
          8.0,
          4.0,
          4.0
        ],
        [
          12.0,
          8.0,
          4.0,
          4.0
        ],
        [
          16.0,
          8.0,
          4.0,
          4.0
        ],
        [
          20.0,
          8.0,
          4.0,
          4.0
        ],
        [
          24.0,
          8.0,
          4.0,
          4.0
        ],
        [
          36.0,
          8.0,
          4.0,
          4.0
        ],
        [
          40.0,
          8.0,
          4.0,
          4.0
        ],
        [
          44.0,
          8.0,
          4.0,
          4.0
        ],
        [
          48.0,
          8.0,
          4.0,
          4.0
        ],
        [
          52.0,
          8.0,
          4.0,
          4.0
        ]
      ]
    }
  ],
  "bot-night": [
    {
      "shade": "primary",
      "rects": [
        [
          8.0,
          4.0,
          4.0,
          4.0
        ],
        [
          12.0,
          4.0,
          4.0,
          4.0
        ],
        [
          16.0,
          4.0,
          4.0,
          4.0
        ],
        [
          20.0,
          4.0,
          4.0,
          4.0
        ],
        [
          24.0,
          4.0,
          4.0,
          4.0
        ],
        [
          36.0,
          4.0,
          4.0,
          4.0
        ],
        [
          40.0,
          4.0,
          4.0,
          4.0
        ],
        [
          44.0,
          4.0,
          4.0,
          4.0
        ],
        [
          48.0,
          4.0,
          4.0,
          4.0
        ],
        [
          52.0,
          4.0,
          4.0,
          4.0
        ],
        [
          8.0,
          8.0,
          4.0,
          4.0
        ],
        [
          12.0,
          8.0,
          4.0,
          4.0
        ],
        [
          16.0,
          8.0,
          4.0,
          4.0
        ],
        [
          20.0,
          8.0,
          4.0,
          4.0
        ],
        [
          24.0,
          8.0,
          4.0,
          4.0
        ],
        [
          36.0,
          8.0,
          4.0,
          4.0
        ],
        [
          40.0,
          8.0,
          4.0,
          4.0
        ],
        [
          44.0,
          8.0,
          4.0,
          4.0
        ],
        [
          48.0,
          8.0,
          4.0,
          4.0
        ],
        [
          52.0,
          8.0,
          4.0,
          4.0
        ],
        [
          8.0,
          12.0,
          4.0,
          4.0
        ],
        [
          12.0,
          12.0,
          4.0,
          4.0
        ],
        [
          16.0,
          12.0,
          4.0,
          4.0
        ],
        [
          20.0,
          12.0,
          4.0,
          4.0
        ],
        [
          24.0,
          12.0,
          4.0,
          4.0
        ],
        [
          36.0,
          12.0,
          4.0,
          4.0
        ],
        [
          40.0,
          12.0,
          4.0,
          4.0
        ],
        [
          44.0,
          12.0,
          4.0,
          4.0
        ],
        [
          48.0,
          12.0,
          4.0,
          4.0
        ],
        [
          52.0,
          12.0,
          4.0,
          4.0
        ]
      ]
    }
  ],
  "bot-pixel-arc": [
    {
      "shade": "primary",
      "rects": [
        [
          8.0,
          6.0,
          2.0,
          2.0
        ],
        [
          10.0,
          6.0,
          2.0,
          2.0
        ],
        [
          40.0,
          6.0,
          2.0,
          2.0
        ],
        [
          42.0,
          6.0,
          2.0,
          2.0
        ],
        [
          8.0,
          8.0,
          2.0,
          2.0
        ],
        [
          10.0,
          8.0,
          2.0,
          2.0
        ],
        [
          40.0,
          8.0,
          2.0,
          2.0
        ],
        [
          42.0,
          8.0,
          2.0,
          2.0
        ],
        [
          8.0,
          10.0,
          2.0,
          2.0
        ],
        [
          10.0,
          10.0,
          2.0,
          2.0
        ],
        [
          12.0,
          10.0,
          2.0,
          2.0
        ],
        [
          14.0,
          10.0,
          2.0,
          2.0
        ],
        [
          36.0,
          10.0,
          2.0,
          2.0
        ],
        [
          38.0,
          10.0,
          2.0,
          2.0
        ],
        [
          40.0,
          10.0,
          2.0,
          2.0
        ],
        [
          42.0,
          10.0,
          2.0,
          2.0
        ],
        [
          12.0,
          12.0,
          2.0,
          2.0
        ],
        [
          14.0,
          12.0,
          2.0,
          2.0
        ],
        [
          16.0,
          12.0,
          2.0,
          2.0
        ],
        [
          18.0,
          12.0,
          2.0,
          2.0
        ],
        [
          20.0,
          12.0,
          2.0,
          2.0
        ],
        [
          22.0,
          12.0,
          2.0,
          2.0
        ],
        [
          32.0,
          12.0,
          2.0,
          2.0
        ],
        [
          34.0,
          12.0,
          2.0,
          2.0
        ],
        [
          36.0,
          12.0,
          2.0,
          2.0
        ],
        [
          38.0,
          12.0,
          2.0,
          2.0
        ],
        [
          40.0,
          12.0,
          2.0,
          2.0
        ],
        [
          42.0,
          12.0,
          2.0,
          2.0
        ],
        [
          16.0,
          14.0,
          2.0,
          2.0
        ],
        [
          18.0,
          14.0,
          2.0,
          2.0
        ],
        [
          20.0,
          14.0,
          2.0,
          2.0
        ],
        [
          22.0,
          14.0,
          2.0,
          2.0
        ],
        [
          32.0,
          14.0,
          2.0,
          2.0
        ],
        [
          34.0,
          14.0,
          2.0,
          2.0
        ],
        [
          36.0,
          14.0,
          2.0,
          2.0
        ],
        [
          38.0,
          14.0,
          2.0,
          2.0
        ]
      ]
    }
  ],
  "bot-pixel-classic": [
    {
      "shade": "primary",
      "rects": [
        [
          8.0,
          4.0,
          2.0,
          2.0
        ],
        [
          10.0,
          4.0,
          2.0,
          2.0
        ],
        [
          12.0,
          4.0,
          2.0,
          2.0
        ],
        [
          14.0,
          4.0,
          2.0,
          2.0
        ],
        [
          16.0,
          4.0,
          2.0,
          2.0
        ],
        [
          18.0,
          4.0,
          2.0,
          2.0
        ],
        [
          36.0,
          4.0,
          2.0,
          2.0
        ],
        [
          38.0,
          4.0,
          2.0,
          2.0
        ],
        [
          40.0,
          4.0,
          2.0,
          2.0
        ],
        [
          42.0,
          4.0,
          2.0,
          2.0
        ],
        [
          44.0,
          4.0,
          2.0,
          2.0
        ],
        [
          46.0,
          4.0,
          2.0,
          2.0
        ],
        [
          8.0,
          6.0,
          2.0,
          2.0
        ],
        [
          10.0,
          6.0,
          2.0,
          2.0
        ],
        [
          16.0,
          6.0,
          2.0,
          2.0
        ],
        [
          18.0,
          6.0,
          2.0,
          2.0
        ],
        [
          36.0,
          6.0,
          2.0,
          2.0
        ],
        [
          38.0,
          6.0,
          2.0,
          2.0
        ],
        [
          44.0,
          6.0,
          2.0,
          2.0
        ],
        [
          46.0,
          6.0,
          2.0,
          2.0
        ],
        [
          8.0,
          8.0,
          2.0,
          2.0
        ],
        [
          10.0,
          8.0,
          2.0,
          2.0
        ],
        [
          16.0,
          8.0,
          2.0,
          2.0
        ],
        [
          18.0,
          8.0,
          2.0,
          2.0
        ],
        [
          36.0,
          8.0,
          2.0,
          2.0
        ],
        [
          38.0,
          8.0,
          2.0,
          2.0
        ],
        [
          44.0,
          8.0,
          2.0,
          2.0
        ],
        [
          46.0,
          8.0,
          2.0,
          2.0
        ],
        [
          8.0,
          10.0,
          2.0,
          2.0
        ],
        [
          10.0,
          10.0,
          2.0,
          2.0
        ],
        [
          12.0,
          10.0,
          2.0,
          2.0
        ],
        [
          14.0,
          10.0,
          2.0,
          2.0
        ],
        [
          16.0,
          10.0,
          2.0,
          2.0
        ],
        [
          18.0,
          10.0,
          2.0,
          2.0
        ],
        [
          36.0,
          10.0,
          2.0,
          2.0
        ],
        [
          38.0,
          10.0,
          2.0,
          2.0
        ],
        [
          40.0,
          10.0,
          2.0,
          2.0
        ],
        [
          42.0,
          10.0,
          2.0,
          2.0
        ],
        [
          44.0,
          10.0,
          2.0,
          2.0
        ],
        [
          46.0,
          10.0,
          2.0,
          2.0
        ]
      ]
    },
    {
      "shade": "bright",
      "rects": [
        [
          12.0,
          6.0,
          2.0,
          2.0
        ],
        [
          14.0,
          6.0,
          2.0,
          2.0
        ],
        [
          40.0,
          6.0,
          2.0,
          2.0
        ],
        [
          42.0,
          6.0,
          2.0,
          2.0
        ],
        [
          12.0,
          8.0,
          2.0,
          2.0
        ],
        [
          14.0,
          8.0,
          2.0,
          2.0
        ],
        [
          40.0,
          8.0,
          2.0,
          2.0
        ],
        [
          42.0,
          8.0,
          2.0,
          2.0
        ]
      ]
    }
  ],
  "bot-pixel-diamond": [
    {
      "shade": "primary",
      "rects": [
        [
          12.0,
          4.0,
          2.0,
          2.0
        ],
        [
          14.0,
          4.0,
          2.0,
          2.0
        ],
        [
          40.0,
          4.0,
          2.0,
          2.0
        ],
        [
          42.0,
          4.0,
          2.0,
          2.0
        ],
        [
          10.0,
          6.0,
          2.0,
          2.0
        ],
        [
          12.0,
          6.0,
          2.0,
          2.0
        ],
        [
          14.0,
          6.0,
          2.0,
          2.0
        ],
        [
          16.0,
          6.0,
          2.0,
          2.0
        ],
        [
          38.0,
          6.0,
          2.0,
          2.0
        ],
        [
          40.0,
          6.0,
          2.0,
          2.0
        ],
        [
          42.0,
          6.0,
          2.0,
          2.0
        ],
        [
          44.0,
          6.0,
          2.0,
          2.0
        ],
        [
          8.0,
          8.0,
          2.0,
          2.0
        ],
        [
          10.0,
          8.0,
          2.0,
          2.0
        ],
        [
          12.0,
          8.0,
          2.0,
          2.0
        ],
        [
          14.0,
          8.0,
          2.0,
          2.0
        ],
        [
          16.0,
          8.0,
          2.0,
          2.0
        ],
        [
          18.0,
          8.0,
          2.0,
          2.0
        ],
        [
          36.0,
          8.0,
          2.0,
          2.0
        ],
        [
          38.0,
          8.0,
          2.0,
          2.0
        ],
        [
          40.0,
          8.0,
          2.0,
          2.0
        ],
        [
          42.0,
          8.0,
          2.0,
          2.0
        ],
        [
          44.0,
          8.0,
          2.0,
          2.0
        ],
        [
          46.0,
          8.0,
          2.0,
          2.0
        ],
        [
          10.0,
          10.0,
          2.0,
          2.0
        ],
        [
          12.0,
          10.0,
          2.0,
          2.0
        ],
        [
          14.0,
          10.0,
          2.0,
          2.0
        ],
        [
          16.0,
          10.0,
          2.0,
          2.0
        ],
        [
          38.0,
          10.0,
          2.0,
          2.0
        ],
        [
          40.0,
          10.0,
          2.0,
          2.0
        ],
        [
          42.0,
          10.0,
          2.0,
          2.0
        ],
        [
          44.0,
          10.0,
          2.0,
          2.0
        ],
        [
          12.0,
          12.0,
          2.0,
          2.0
        ],
        [
          14.0,
          12.0,
          2.0,
          2.0
        ],
        [
          40.0,
          12.0,
          2.0,
          2.0
        ],
        [
          42.0,
          12.0,
          2.0,
          2.0
        ]
      ]
    }
  ],
  "bot-pixel-led": [
    {
      "shade": "primary",
      "rects": [
        [
          10.0,
          4.0,
          2.0,
          2.0
        ],
        [
          12.0,
          4.0,
          2.0,
          2.0
        ],
        [
          14.0,
          4.0,
          2.0,
          2.0
        ],
        [
          16.0,
          4.0,
          2.0,
          2.0
        ],
        [
          40.0,
          4.0,
          2.0,
          2.0
        ],
        [
          42.0,
          4.0,
          2.0,
          2.0
        ],
        [
          44.0,
          4.0,
          2.0,
          2.0
        ],
        [
          46.0,
          4.0,
          2.0,
          2.0
        ],
        [
          8.0,
          6.0,
          2.0,
          2.0
        ],
        [
          10.0,
          6.0,
          2.0,
          2.0
        ],
        [
          12.0,
          6.0,
          2.0,
          2.0
        ],
        [
          14.0,
          6.0,
          2.0,
          2.0
        ],
        [
          16.0,
          6.0,
          2.0,
          2.0
        ],
        [
          18.0,
          6.0,
          2.0,
          2.0
        ],
        [
          38.0,
          6.0,
          2.0,
          2.0
        ],
        [
          40.0,
          6.0,
          2.0,
          2.0
        ],
        [
          42.0,
          6.0,
          2.0,
          2.0
        ],
        [
          44.0,
          6.0,
          2.0,
          2.0
        ],
        [
          46.0,
          6.0,
          2.0,
          2.0
        ],
        [
          48.0,
          6.0,
          2.0,
          2.0
        ],
        [
          8.0,
          8.0,
          2.0,
          2.0
        ],
        [
          10.0,
          8.0,
          2.0,
          2.0
        ],
        [
          16.0,
          8.0,
          2.0,
          2.0
        ],
        [
          18.0,
          8.0,
          2.0,
          2.0
        ],
        [
          38.0,
          8.0,
          2.0,
          2.0
        ],
        [
          40.0,
          8.0,
          2.0,
          2.0
        ],
        [
          46.0,
          8.0,
          2.0,
          2.0
        ],
        [
          48.0,
          8.0,
          2.0,
          2.0
        ],
        [
          8.0,
          10.0,
          2.0,
          2.0
        ],
        [
          10.0,
          10.0,
          2.0,
          2.0
        ],
        [
          16.0,
          10.0,
          2.0,
          2.0
        ],
        [
          18.0,
          10.0,
          2.0,
          2.0
        ],
        [
          38.0,
          10.0,
          2.0,
          2.0
        ],
        [
          40.0,
          10.0,
          2.0,
          2.0
        ],
        [
          46.0,
          10.0,
          2.0,
          2.0
        ],
        [
          48.0,
          10.0,
          2.0,
          2.0
        ],
        [
          8.0,
          12.0,
          2.0,
          2.0
        ],
        [
          10.0,
          12.0,
          2.0,
          2.0
        ],
        [
          12.0,
          12.0,
          2.0,
          2.0
        ],
        [
          14.0,
          12.0,
          2.0,
          2.0
        ],
        [
          16.0,
          12.0,
          2.0,
          2.0
        ],
        [
          18.0,
          12.0,
          2.0,
          2.0
        ],
        [
          38.0,
          12.0,
          2.0,
          2.0
        ],
        [
          40.0,
          12.0,
          2.0,
          2.0
        ],
        [
          42.0,
          12.0,
          2.0,
          2.0
        ],
        [
          44.0,
          12.0,
          2.0,
          2.0
        ],
        [
          46.0,
          12.0,
          2.0,
          2.0
        ],
        [
          48.0,
          12.0,
          2.0,
          2.0
        ],
        [
          10.0,
          14.0,
          2.0,
          2.0
        ],
        [
          12.0,
          14.0,
          2.0,
          2.0
        ],
        [
          14.0,
          14.0,
          2.0,
          2.0
        ],
        [
          16.0,
          14.0,
          2.0,
          2.0
        ],
        [
          40.0,
          14.0,
          2.0,
          2.0
        ],
        [
          42.0,
          14.0,
          2.0,
          2.0
        ],
        [
          44.0,
          14.0,
          2.0,
          2.0
        ],
        [
          46.0,
          14.0,
          2.0,
          2.0
        ]
      ]
    },
    {
      "shade": "bright",
      "rects": [
        [
          12.0,
          8.0,
          2.0,
          2.0
        ],
        [
          14.0,
          8.0,
          2.0,
          2.0
        ],
        [
          42.0,
          8.0,
          2.0,
          2.0
        ],
        [
          44.0,
          8.0,
          2.0,
          2.0
        ],
        [
          12.0,
          10.0,
          2.0,
          2.0
        ],
        [
          14.0,
          10.0,
          2.0,
          2.0
        ],
        [
          42.0,
          10.0,
          2.0,
          2.0
        ],
        [
          44.0,
          10.0,
          2.0,
          2.0
        ]
      ]
    }
  ],
  "bot-pixel-scan": [
    {
      "shade": "primary",
      "rects": [
        [
          4.0,
          6.0,
          2.0,
          2.0
        ],
        [
          6.0,
          6.0,
          2.0,
          2.0
        ],
        [
          8.0,
          6.0,
          2.0,
          2.0
        ],
        [
          10.0,
          6.0,
          2.0,
          2.0
        ],
        [
          12.0,
          6.0,
          2.0,
          2.0
        ],
        [
          14.0,
          6.0,
          2.0,
          2.0
        ],
        [
          16.0,
          6.0,
          2.0,
          2.0
        ],
        [
          18.0,
          6.0,
          2.0,
          2.0
        ],
        [
          20.0,
          6.0,
          2.0,
          2.0
        ],
        [
          22.0,
          6.0,
          2.0,
          2.0
        ],
        [
          24.0,
          6.0,
          2.0,
          2.0
        ],
        [
          26.0,
          6.0,
          2.0,
          2.0
        ],
        [
          36.0,
          6.0,
          2.0,
          2.0
        ],
        [
          38.0,
          6.0,
          2.0,
          2.0
        ],
        [
          40.0,
          6.0,
          2.0,
          2.0
        ],
        [
          42.0,
          6.0,
          2.0,
          2.0
        ],
        [
          44.0,
          6.0,
          2.0,
          2.0
        ],
        [
          46.0,
          6.0,
          2.0,
          2.0
        ],
        [
          48.0,
          6.0,
          2.0,
          2.0
        ],
        [
          50.0,
          6.0,
          2.0,
          2.0
        ],
        [
          52.0,
          6.0,
          2.0,
          2.0
        ],
        [
          54.0,
          6.0,
          2.0,
          2.0
        ],
        [
          56.0,
          6.0,
          2.0,
          2.0
        ],
        [
          58.0,
          6.0,
          2.0,
          2.0
        ],
        [
          4.0,
          8.0,
          2.0,
          2.0
        ],
        [
          6.0,
          8.0,
          2.0,
          2.0
        ],
        [
          56.0,
          8.0,
          2.0,
          2.0
        ],
        [
          58.0,
          8.0,
          2.0,
          2.0
        ],
        [
          4.0,
          10.0,
          2.0,
          2.0
        ],
        [
          6.0,
          10.0,
          2.0,
          2.0
        ],
        [
          8.0,
          10.0,
          2.0,
          2.0
        ],
        [
          10.0,
          10.0,
          2.0,
          2.0
        ],
        [
          12.0,
          10.0,
          2.0,
          2.0
        ],
        [
          14.0,
          10.0,
          2.0,
          2.0
        ],
        [
          16.0,
          10.0,
          2.0,
          2.0
        ],
        [
          18.0,
          10.0,
          2.0,
          2.0
        ],
        [
          20.0,
          10.0,
          2.0,
          2.0
        ],
        [
          22.0,
          10.0,
          2.0,
          2.0
        ],
        [
          24.0,
          10.0,
          2.0,
          2.0
        ],
        [
          26.0,
          10.0,
          2.0,
          2.0
        ],
        [
          36.0,
          10.0,
          2.0,
          2.0
        ],
        [
          38.0,
          10.0,
          2.0,
          2.0
        ],
        [
          40.0,
          10.0,
          2.0,
          2.0
        ],
        [
          42.0,
          10.0,
          2.0,
          2.0
        ],
        [
          44.0,
          10.0,
          2.0,
          2.0
        ],
        [
          46.0,
          10.0,
          2.0,
          2.0
        ],
        [
          48.0,
          10.0,
          2.0,
          2.0
        ],
        [
          50.0,
          10.0,
          2.0,
          2.0
        ],
        [
          52.0,
          10.0,
          2.0,
          2.0
        ],
        [
          54.0,
          10.0,
          2.0,
          2.0
        ],
        [
          56.0,
          10.0,
          2.0,
          2.0
        ],
        [
          58.0,
          10.0,
          2.0,
          2.0
        ]
      ]
    },
    {
      "shade": "bright",
      "rects": [
        [
          8.0,
          8.0,
          2.0,
          2.0
        ],
        [
          10.0,
          8.0,
          2.0,
          2.0
        ],
        [
          12.0,
          8.0,
          2.0,
          2.0
        ],
        [
          14.0,
          8.0,
          2.0,
          2.0
        ],
        [
          16.0,
          8.0,
          2.0,
          2.0
        ],
        [
          18.0,
          8.0,
          2.0,
          2.0
        ],
        [
          20.0,
          8.0,
          2.0,
          2.0
        ],
        [
          22.0,
          8.0,
          2.0,
          2.0
        ],
        [
          24.0,
          8.0,
          2.0,
          2.0
        ],
        [
          26.0,
          8.0,
          2.0,
          2.0
        ],
        [
          36.0,
          8.0,
          2.0,
          2.0
        ],
        [
          38.0,
          8.0,
          2.0,
          2.0
        ],
        [
          40.0,
          8.0,
          2.0,
          2.0
        ],
        [
          42.0,
          8.0,
          2.0,
          2.0
        ],
        [
          44.0,
          8.0,
          2.0,
          2.0
        ],
        [
          46.0,
          8.0,
          2.0,
          2.0
        ],
        [
          48.0,
          8.0,
          2.0,
          2.0
        ],
        [
          50.0,
          8.0,
          2.0,
          2.0
        ],
        [
          52.0,
          8.0,
          2.0,
          2.0
        ],
        [
          54.0,
          8.0,
          2.0,
          2.0
        ]
      ]
    }
  ],
  "bot-pixel-soft": [
    {
      "shade": "primary",
      "rects": [
        [
          12.0,
          10.0,
          2.0,
          2.0
        ],
        [
          14.0,
          10.0,
          2.0,
          2.0
        ],
        [
          40.0,
          10.0,
          2.0,
          2.0
        ],
        [
          42.0,
          10.0,
          2.0,
          2.0
        ],
        [
          10.0,
          12.0,
          2.0,
          2.0
        ],
        [
          12.0,
          12.0,
          2.0,
          2.0
        ],
        [
          14.0,
          12.0,
          2.0,
          2.0
        ],
        [
          16.0,
          12.0,
          2.0,
          2.0
        ],
        [
          38.0,
          12.0,
          2.0,
          2.0
        ],
        [
          40.0,
          12.0,
          2.0,
          2.0
        ],
        [
          42.0,
          12.0,
          2.0,
          2.0
        ],
        [
          44.0,
          12.0,
          2.0,
          2.0
        ],
        [
          12.0,
          14.0,
          2.0,
          2.0
        ],
        [
          14.0,
          14.0,
          2.0,
          2.0
        ],
        [
          40.0,
          14.0,
          2.0,
          2.0
        ],
        [
          42.0,
          14.0,
          2.0,
          2.0
        ]
      ]
    }
  ],
  "bot-spark": [
    {
      "shade": "primary",
      "rects": [
        [
          16.0,
          0.0,
          4.0,
          4.0
        ],
        [
          48.0,
          0.0,
          4.0,
          4.0
        ],
        [
          8.0,
          4.0,
          4.0,
          4.0
        ],
        [
          12.0,
          4.0,
          4.0,
          4.0
        ],
        [
          16.0,
          4.0,
          4.0,
          4.0
        ],
        [
          20.0,
          4.0,
          4.0,
          4.0
        ],
        [
          24.0,
          4.0,
          4.0,
          4.0
        ],
        [
          36.0,
          4.0,
          4.0,
          4.0
        ],
        [
          40.0,
          4.0,
          4.0,
          4.0
        ],
        [
          44.0,
          4.0,
          4.0,
          4.0
        ],
        [
          48.0,
          4.0,
          4.0,
          4.0
        ],
        [
          52.0,
          4.0,
          4.0,
          4.0
        ],
        [
          8.0,
          8.0,
          4.0,
          4.0
        ],
        [
          12.0,
          8.0,
          4.0,
          4.0
        ],
        [
          16.0,
          8.0,
          4.0,
          4.0
        ],
        [
          20.0,
          8.0,
          4.0,
          4.0
        ],
        [
          24.0,
          8.0,
          4.0,
          4.0
        ],
        [
          36.0,
          8.0,
          4.0,
          4.0
        ],
        [
          40.0,
          8.0,
          4.0,
          4.0
        ],
        [
          44.0,
          8.0,
          4.0,
          4.0
        ],
        [
          48.0,
          8.0,
          4.0,
          4.0
        ],
        [
          52.0,
          8.0,
          4.0,
          4.0
        ],
        [
          8.0,
          12.0,
          4.0,
          4.0
        ],
        [
          12.0,
          12.0,
          4.0,
          4.0
        ],
        [
          16.0,
          12.0,
          4.0,
          4.0
        ],
        [
          20.0,
          12.0,
          4.0,
          4.0
        ],
        [
          24.0,
          12.0,
          4.0,
          4.0
        ],
        [
          36.0,
          12.0,
          4.0,
          4.0
        ],
        [
          40.0,
          12.0,
          4.0,
          4.0
        ],
        [
          44.0,
          12.0,
          4.0,
          4.0
        ],
        [
          48.0,
          12.0,
          4.0,
          4.0
        ],
        [
          52.0,
          12.0,
          4.0,
          4.0
        ]
      ]
    }
  ],
  "bot-thinking": [
    {
      "shade": "primary",
      "rects": [
        [
          28.0,
          0.0,
          4.0,
          4.0
        ],
        [
          60.0,
          0.0,
          4.0,
          4.0
        ],
        [
          8.0,
          4.0,
          4.0,
          4.0
        ],
        [
          12.0,
          4.0,
          4.0,
          4.0
        ],
        [
          16.0,
          4.0,
          4.0,
          4.0
        ],
        [
          20.0,
          4.0,
          4.0,
          4.0
        ],
        [
          36.0,
          4.0,
          4.0,
          4.0
        ],
        [
          40.0,
          4.0,
          4.0,
          4.0
        ],
        [
          44.0,
          4.0,
          4.0,
          4.0
        ],
        [
          48.0,
          4.0,
          4.0,
          4.0
        ],
        [
          52.0,
          4.0,
          4.0,
          4.0
        ],
        [
          8.0,
          8.0,
          4.0,
          4.0
        ],
        [
          12.0,
          8.0,
          4.0,
          4.0
        ],
        [
          16.0,
          8.0,
          4.0,
          4.0
        ],
        [
          20.0,
          8.0,
          4.0,
          4.0
        ],
        [
          36.0,
          8.0,
          4.0,
          4.0
        ],
        [
          40.0,
          8.0,
          4.0,
          4.0
        ],
        [
          44.0,
          8.0,
          4.0,
          4.0
        ],
        [
          48.0,
          8.0,
          4.0,
          4.0
        ],
        [
          52.0,
          8.0,
          4.0,
          4.0
        ],
        [
          8.0,
          12.0,
          4.0,
          4.0
        ],
        [
          12.0,
          12.0,
          4.0,
          4.0
        ],
        [
          16.0,
          12.0,
          4.0,
          4.0
        ],
        [
          20.0,
          12.0,
          4.0,
          4.0
        ],
        [
          36.0,
          12.0,
          4.0,
          4.0
        ],
        [
          40.0,
          12.0,
          4.0,
          4.0
        ],
        [
          44.0,
          12.0,
          4.0,
          4.0
        ],
        [
          48.0,
          12.0,
          4.0,
          4.0
        ],
        [
          52.0,
          12.0,
          4.0,
          4.0
        ]
      ]
    }
  ],
  "bot-zen": [
    {
      "shade": "primary",
      "rects": [
        [
          8.0,
          12.0,
          4.0,
          4.0
        ],
        [
          24.0,
          12.0,
          4.0,
          4.0
        ],
        [
          36.0,
          12.0,
          4.0,
          4.0
        ],
        [
          52.0,
          12.0,
          4.0,
          4.0
        ],
        [
          12.0,
          16.0,
          4.0,
          4.0
        ],
        [
          16.0,
          16.0,
          4.0,
          4.0
        ],
        [
          20.0,
          16.0,
          4.0,
          4.0
        ],
        [
          40.0,
          16.0,
          4.0,
          4.0
        ],
        [
          44.0,
          16.0,
          4.0,
          4.0
        ],
        [
          48.0,
          16.0,
          4.0,
          4.0
        ]
      ]
    }
  ]
};

export const EYE_VIEWBOX = { w: 64, h: 24 };
